import instance,{BASE_URL} from "../../services/api";
import toast from 'react-hot-toast';


const MasterViewController = () => {
  const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};
  const getRoles = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(`${BASE_URL}roles/`);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_ROLES_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_ROLES_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };
  const addRole = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}roles/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_ROLE_SUCCESS", payload: data });
      dispatch(getRoles());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Role added sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_ROLE_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const updateRole = (roleId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}roles/${roleId}/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_ROLE_SUCCESS", payload: data });
      dispatch(getRoles());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Role updated sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "UPDATE_ROLE_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const deleteRole = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}roles/${reqData}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_ROLE_SUCCESS", payload: data });
      dispatch(getRoles());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Role deleted sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_ROLE_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const getDepartments = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}departments/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_DEPARTMENTS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_DEPARTMENTS_FAILURE",
        payload: { error: error },
      });
      toast.error(message)
    }
  };

  const addDepartments = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}departments/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_DEPARTMENTS_SUCCESS", payload: data });
      dispatch(getDepartments());
      dispatch({ type: "LOADING", payload: false });
      toast.success(" Department added sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_DEPARTMENTS_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const updateDepartment = (departmentId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}departments/${departmentId}/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_DEPARTMENT_SUCCESS", payload: data });
      dispatch(getDepartments());
      dispatch({ type: "LOADING", payload: false });
       toast.success("Department updated sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "UPDATE_DEPARTMENT_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const deleteDepartment = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}departments/${reqData}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_DEPARTMENT_SUCCESS", payload: data });
      dispatch(getDepartments());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Department deleted sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_DEPARTMENT_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const getDesignations = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}designations/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);

      dispatch({ type: "GET_DESIGNATIONS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_DESIGNATIONS_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const addDesignation = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}designations/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_DESIGNATION_SUCCESS", payload: data });
      dispatch(getDesignations());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Designation added sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_DESIGNATION_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const updateDesignation = (designationId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}designations/${designationId}/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_DESIGNATION_SUCCESS", payload: data });
      dispatch(getDesignations());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Designation updated sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "UPDATE_DESIGNATION_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const deleteDesignation = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}designations/${reqData}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_DESIGNATION_SUCCESS", payload: data });
      dispatch(getDesignations());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Designation Deleted sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_DESIGNATION_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const getHolidays = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}holiday-master/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_MASTER_HOLIDAYS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_HOLIDAYS_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const addHolidays = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}holiday-master/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_HOLIDAYS_SUCCESS", payload: data });
      dispatch(getHolidays());
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_HOLIDAYS_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };
 
  const updateHoliday = (holidayId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}holiday-master/${holidayId}/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_HOLIDAY_MASTER_SUCCESS", payload: data });
      dispatch(getHolidays());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Holiday Master updated sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "UPDATE_HOLIDAY_MASTER_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

 const getPermissionsModules = (userType) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(`${BASE_URL}permission-modules/${userType}/`);
console.log("Response from getPermissionsModules:", response.data);
console.log("userType",userType);


      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_PERMISSION_MODULES_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_PERMISSION_MODULES_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

 const getChallanMaster = (companyId = null) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const params = companyId ? { company_id: companyId } : undefined;
      const response = await instance.get(`${BASE_URL}challans/`, { params });

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_CHALLAN_MASTER_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      // const message = getErrorMessage(error);
      dispatch({
        type: "GET_CHALLAN_MASTER_FAILURE",
        payload: { error: error },
      });
      // toast.error(message);
    }
  };

  const addChallanMaster = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}challans/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_CHALLAN_MASTER_SUCCESS", payload: data });
      dispatch(getChallanMaster());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Challan added sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_CHALLAN_MASTER_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

   const updateChallan = (challanId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}challans/${challanId}/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_CHALLAN_SUCCESS", payload: data });
      dispatch(getChallanMaster());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Challan updated sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "UPDATE_CHALLAN_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const deleteChallan = (challanId) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      await instance.delete(`${BASE_URL}challans/${challanId}/`);
      dispatch({ type: "DELETE_CHALLAN_SUCCESS", payload: challanId });
      dispatch(getChallanMaster());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Challan deleted successfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_CHALLAN_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };
 
    const getPermissionMasters = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(`${BASE_URL}permission-master/`);
      dispatch({ type: "GET_PERMISSION_MASTERS_SUCCESS", payload: response.data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      toast.error(getErrorMessage(error));
    }
  };
  const addPermissionMaster = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      await instance.post(`${BASE_URL}permission-master/`, reqData);
      dispatch(getPermissionMasters());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Permission module added");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      toast.error(getErrorMessage(error));
    }
  };
  const updatePermissionMaster = (id, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      await instance.put(`${BASE_URL}permission-master/${id}/`, reqData);
      dispatch(getPermissionMasters());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Permission module updated");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      toast.error(getErrorMessage(error));
    }
  };
  const deletePermissionMaster = (id) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      await instance.delete(`${BASE_URL}permission-master/${id}/`);
      dispatch(getPermissionMasters());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Permission module deleted");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      toast.error(getErrorMessage(error));
    }
  };

  return {
    getRoles,
    addRole,
    updateRole,
    deleteRole,
    getDepartments,
    addDepartments,
    updateDepartment,
    deleteDepartment,
    getDesignations,
    addDesignation,
    updateHoliday,
    updateDesignation,
    deleteDesignation,
    getHolidays,
    addHolidays,
    getPermissionsModules ,
    getChallanMaster, 
    addChallanMaster,
    updateChallan,
    deleteChallan,
    getPermissionMasters,
    addPermissionMaster,
    updatePermissionMaster,
    deletePermissionMaster,
  };
};

export default MasterViewController;
